export const copyUrl = async (url: string, name: string) => {
  const link = `<a href="${url}">${name}</a>`;
  const html = new Blob([link], { type: 'text/html' });
  const text = new Blob([url], { type: 'text/plain' });
  const item = new ClipboardItem({ 'text/html': html, 'text/plain': text });
  await navigator.clipboard.write([item]);
};
